import React from 'react';
import { BarChart3, TrendingUp, Star, Handshake } from 'lucide-react';
export function FeatureAnalytics() {
  return <section className="w-full border-b border-white/[0.06]" style={{
    backgroundColor: '#09090B'
  }} data-id="element-209">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28" data-id="element-210">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center max-w-2xl mx-auto leading-tight font-heading" data-id="element-211">
          Après l'événement, les questions commencent. MeetOS y répond.
        </h2>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-212">
          {/* Card 1 — Présence */}
          <div className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-6 text-center" data-id="element-213">
            <BarChart3 className="h-8 w-8 text-blue-400 mx-auto" data-id="element-214" />
            <h3 className="text-white font-semibold mt-4 font-heading" data-id="element-215">
              Présence
            </h3>
            <p className="text-white/50 text-sm mt-2 leading-relaxed" data-id="element-216">
              Taux de présence session par session, croisé avec les données de
              check-in
            </p>
          </div>

          {/* Card 2 — Networking */}
          <div className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-6 text-center" data-id="element-217">
            <TrendingUp className="h-8 w-8 text-purple-400 mx-auto" data-id="element-218" />
            <h3 className="text-white font-semibold mt-4 font-heading" data-id="element-219">
              Networking
            </h3>
            <p className="text-white/50 text-sm mt-2 leading-relaxed" data-id="element-220">
              Réunions demandées, confirmées et tenues — funnel de conversion
              complet par événement
            </p>
          </div>

          {/* Card 3 — Engagement */}
          <div className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-6 text-center" data-id="element-221">
            <Star className="h-8 w-8 text-cyan-400 mx-auto" data-id="element-222" />
            <h3 className="text-white font-semibold mt-4 font-heading" data-id="element-223">
              Engagement
            </h3>
            <p className="text-white/50 text-sm mt-2 leading-relaxed" data-id="element-224">
              Score d'engagement composite par participant : sessions, réunions,
              messages, posts
            </p>
          </div>

          {/* Card 4 — ROI Exposants */}
          <div className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-6 text-center" data-id="element-225">
            <Handshake className="h-8 w-8 text-emerald-400 mx-auto" data-id="element-226" />
            <h3 className="text-white font-semibold mt-4 font-heading" data-id="element-227">
              ROI Exposants
            </h3>
            <p className="text-white/50 text-sm mt-2 leading-relaxed" data-id="element-228">
              Leads capturés par partenaire. Scans de badges par stand.
              Exportable.
            </p>
          </div>
        </div>

        <p className="mt-10 text-center text-sm text-white/40 font-mono" data-id="element-229">
          Tous les rapports sont brandés et exportables. Livrés dans les 24
          heures suivant la clôture.
        </p>
      </div>
    </section>;
}